/* eslint-disable import/prefer-default-export */
// External Dependencies
import axios from 'axios';
import { toast } from 'react-toastify';

// Internal Dependencies
import { ADD_MASTER_NAME, DELETE_MASTER_NAME, GET_MASTER_NAME, UPDATE_MASTER_NAME } from '../types';
import { ThrowErrorMsg } from '../util';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../services.js/apiService';

const basePathStaff = `${process.env.REACT_APP_API_URL}/staff`;

export const addMasterName = (data) => async (dispatch) => {
  try {
    const payload = { masterName: data.masterName, names: data.names };
    const masterName = await postRequest(`${basePathStaff}/mastername`, payload);

    dispatch({
      type:    ADD_MASTER_NAME,
      payload: masterName,
    });

    return masterName;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const deleteMasterName = (id) => async (dispatch) => {
  try {
    await deleteRequest(`${basePathStaff}/mastername/${id}`);

    dispatch({
      type:    DELETE_MASTER_NAME,
      payload: id,
    });

    toast.success('Master name deleted.');
  } catch (err) {
    toast.error(`Unable to delete master name ${err.message}`);
    if (err.response !== undefined) {
      const error = err.response.data;
      toast.error(error);
    }
  }
};

export const updateMasterName = (data) => async (dispatch) => {
  try {
    const { oldMasterName, masterName, names } = data;
    const payload = { masterName, names };

    const updated = await putRequest(`${basePathStaff}/mastername/${oldMasterName}`, payload);

    dispatch({
      type:    UPDATE_MASTER_NAME,
      payload: updated,
    });

    return updated;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const getPaginateMasterNames = (query) => async (dispatch) => {
  try {
    const params = { ...query, pageNo: query.page };
    const list = await getRequest(`${basePathStaff}/masternames`, params);

    dispatch({
      type:    GET_MASTER_NAME,
      payload: list,
    });

    return list;
  } catch (err) {
    if (err.response !== undefined) {
      const error = err.response.data.message;
      toast.error(error);
    }
  }
};
